import { useCallback, useEffect, useRef, useState } from 'react'
import type { LoadLicenseCatalog } from '@/shared/domain'
import type { LicenseCatalog } from '@/shared/domain'
import { LicenseCatalogCtx, LicenseCatalogRequestLoadCtx } from '@/shared/ui/hooks'

type LicenseCatalogProviderProps = {
  onLoadLicenseCatalog: LoadLicenseCatalog
  children: React.ReactNode
}

export function LicenseCatalogProvider({
  onLoadLicenseCatalog,
  children,
}: LicenseCatalogProviderProps) {
  const [catalog, setCatalog] = useState<LicenseCatalog | null>(null)
  const [requested, setRequested] = useState(false)
  const hasRequested = useRef(false)

  const requestLoad = useCallback(() => {
    if (hasRequested.current) return
    hasRequested.current = true
    setRequested(true)
  }, [])

  useEffect(() => {
    if (!requested) return
    let cancelled = false
    onLoadLicenseCatalog()
      .then((data) => {
        if (cancelled) return
        setCatalog(data)
      })
      .catch(() => {
        if (cancelled) return
        setCatalog({ jurisdictions: [], licenseTypes: [] })
      })
    return () => {
      cancelled = true
    }
  }, [requested, onLoadLicenseCatalog])

  return (
    <LicenseCatalogRequestLoadCtx.Provider value={requestLoad}>
      <LicenseCatalogCtx.Provider value={catalog}>{children}</LicenseCatalogCtx.Provider>
    </LicenseCatalogRequestLoadCtx.Provider>
  )
}
